import { render, staticRenderFns } from "./vendorApply.vue?vue&type=template&id=4ca2199a&scoped=true"
import script from "./vendorApply.vue?vue&type=script&lang=js"
export * from "./vendorApply.vue?vue&type=script&lang=js"
import style0 from "./vendorApply.vue?vue&type=style&index=0&id=4ca2199a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2199a",
  null
  
)

export default component.exports